/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_Compareselected1Inputs */

const id_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandingkan penawaran yang dipilih`)
};

const ms_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandingkan tawaran dipilih`)
};

const da_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenlign valgte tilbud`)
};

const de_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Angebote vergleichen`)
};

const en_us2_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare selected offers`)
};

const es_es2_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar ofertas seleccionadas`)
};

const es_mx2_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar ofertas seleccionadas`)
};

const fil_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihambing ang mga napiling offer`)
};

const fr_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer les offres sélectionnées`)
};

const it_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta offerte selezionate`)
};

const hu_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiválasztott ajánlatok összehasonlítása`)
};

const nl_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergelijk geselecteerde aanbiedingen`)
};

const no_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenlign valgte tilbud`)
};

const pl_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porównaj wybrane oferty`)
};

const pt_br2_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare Selected`)
};

const pt_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar ofertas selecionadas`)
};

const ro_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compară ofertele selectate`)
};

const fi_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertaile valittuja tarjouksia`)
};

const sv_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jämför valda erbjudanden`)
};

const vi_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So sánh các ưu đãi đã chọn`)
};

const tr_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seçilen teklifleri karşılaştır`)
};

const cs_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porovnat vybrané nabídky`)
};

const bg_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравняване на избраните оферти`)
};

const ru_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнить выбранные предложения`)
};

const uk_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Порівняти вибрані пропозиції`)
};

const ar_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقارنة العروض المحددة`)
};

const hi_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित ऑफ़र की तुलना करें`)
};

const th_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปรียบเทียบข้อเสนอที่เลือก`)
};

const ja_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したオファーを比較`)
};

const zh_cn2_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare Selected`)
};

const zh_hant1_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare Selected`)
};

const ko_components_comparison_compareselected1 = /** @type {(inputs: Components_Comparison_Compareselected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare Selected`)
};

/**
* | output |
* | --- |
* | "Compare selected offers" |
*
* @param {Components_Comparison_Compareselected1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_compareselected1 = /** @type {((inputs?: Components_Comparison_Compareselected1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_Compareselected1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_compareselected1(inputs)
	if (locale === "ms") return ms_components_comparison_compareselected1(inputs)
	if (locale === "da") return da_components_comparison_compareselected1(inputs)
	if (locale === "de") return de_components_comparison_compareselected1(inputs)
	if (locale === "en-US") return en_us2_components_comparison_compareselected1(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_compareselected1(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_compareselected1(inputs)
	if (locale === "fil") return fil_components_comparison_compareselected1(inputs)
	if (locale === "fr") return fr_components_comparison_compareselected1(inputs)
	if (locale === "it") return it_components_comparison_compareselected1(inputs)
	if (locale === "hu") return hu_components_comparison_compareselected1(inputs)
	if (locale === "nl") return nl_components_comparison_compareselected1(inputs)
	if (locale === "no") return no_components_comparison_compareselected1(inputs)
	if (locale === "pl") return pl_components_comparison_compareselected1(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_compareselected1(inputs)
	if (locale === "pt") return pt_components_comparison_compareselected1(inputs)
	if (locale === "ro") return ro_components_comparison_compareselected1(inputs)
	if (locale === "fi") return fi_components_comparison_compareselected1(inputs)
	if (locale === "sv") return sv_components_comparison_compareselected1(inputs)
	if (locale === "vi") return vi_components_comparison_compareselected1(inputs)
	if (locale === "tr") return tr_components_comparison_compareselected1(inputs)
	if (locale === "cs") return cs_components_comparison_compareselected1(inputs)
	if (locale === "bg") return bg_components_comparison_compareselected1(inputs)
	if (locale === "ru") return ru_components_comparison_compareselected1(inputs)
	if (locale === "uk") return uk_components_comparison_compareselected1(inputs)
	if (locale === "ar") return ar_components_comparison_compareselected1(inputs)
	if (locale === "hi") return hi_components_comparison_compareselected1(inputs)
	if (locale === "th") return th_components_comparison_compareselected1(inputs)
	if (locale === "ja") return ja_components_comparison_compareselected1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_compareselected1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_compareselected1(inputs)
	return ko_components_comparison_compareselected1(inputs)
});
export { components_comparison_compareselected1 as "components.comparison.compareSelected" }